// форматирует msisdn к виду +7 900 000 00 00
const formatMsisdn = (msisdn: string): string =>
  `+${msisdn.substr(0, 1)} ${msisdn.substr(1, 3)} ${msisdn.substr(4, 3)} ${msisdn.substr(
    7,
    2
  )} ${msisdn.substr(9, 2)}`;

export default formatMsisdn;
